export const getCardType = (cardNumber = "") => {
  // Remove all non-digit characters from the card number
  const cleanedCardNumber = cardNumber.replace(/\D/g, "");

  // Check the card number against known patterns
  if (cleanedCardNumber.startsWith("4")) {
    return "Visa";
  } else if (cleanedCardNumber.startsWith("5")) {
    return "MasterCard";
  } else if (
    cleanedCardNumber.startsWith("34") ||
    cleanedCardNumber.startsWith("37")
  ) {
    return "American Express";
  } else if (
    cleanedCardNumber.startsWith("6011") ||
    cleanedCardNumber.startsWith("65")
  ) {
    return "Discover";
  } else if (
    cleanedCardNumber.startsWith("30") ||
    cleanedCardNumber.startsWith("36") ||
    cleanedCardNumber.startsWith("38")
  ) {
    return "Diners Club";
  } else if (cleanedCardNumber.startsWith("35")) {
    return "JCB";
  } else if (
    cleanedCardNumber.startsWith("5019") ||
    cleanedCardNumber.startsWith("5020") ||
    cleanedCardNumber.startsWith("5038") ||
    cleanedCardNumber.startsWith("6304")
  ) {
    return "Maestro";
  } else if (
    cleanedCardNumber.startsWith("62") ||
    cleanedCardNumber.startsWith("88")
  ) {
    return "China UnionPay";
  } else {
    return "Unknown";
  }
};
